import React, { useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import FormFieldError from 'src/components/general/FormFieldError';
import { tryGetHolidayTypes } from '../../../redux/holiday/holidayActionCreator';
import { getHolidayTypeListData } from 'src/redux/holiday/holidayReducer';

const HolidayForm = () => {

    const dispatch = useDispatch();
    const { register, errors, holidayToEdit } = useFormContext();

    const holidayTypeList = useSelector(state => getHolidayTypeListData(state))?.records;

    const defaultParams = {
        pageNumber: 0,
        pageSize: 9999,
        sort: 'id,asc'
    };

    const dateRequiredMsg = 'Debe ingresar la Fecha.';
    const nameRequiredMsg = 'Debe ingresar el Nombre.';
    const typeRequiredMsg = 'Debe ingresar el Tipo.';

    const dateValidationObj = { required: dateRequiredMsg };
    const nameValidationObj = { required: nameRequiredMsg };
    const typeValidationObj = { required: typeRequiredMsg };

    useEffect(() => {
        dispatch(tryGetHolidayTypes(defaultParams));
    }, []);

    return <>
        <Form.Group as={Row} controlId='alias'>
            <Form.Label className='text-right text-black-color pr-0 pl-0 d-flex mandatory-label' column sm={4}>
                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                Fecha:
            </Form.Label>
            <Col sm={4}>
                <Form.Control
                    ref={register(dateValidationObj)}
                    type='date'
                    name='year'
                    max='2100'
                    min='1990'
                    defaultValue={holidayToEdit?.date}
                />
                <FormFieldError errors={errors?.year} />
            </Col>
        </Form.Group>

        <Form.Group as={Row} controlId='alias'>
            <Form.Label className='text-right text-black-color pr-0 pl-0 d-flex mandatory-label' column sm={4}>
                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                Nombre:
            </Form.Label>
            <Col sm={4}>
                <Form.Control
                    ref={register(nameValidationObj)}
                    as='textarea'
                    placeholder='Nombre'
                    name='name'
                    disabled={false}
                    defaultValue={holidayToEdit?.name}
                    maxLength={1000}
                />
                <FormFieldError errors={errors?.name} />
            </Col>
        </Form.Group>

        <Form.Group as={Row} controlId='type'>
            <Form.Label className='text-right text-black-color pr-0 pl-0 d-flex mandatory-label' column sm={4}>
                <FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
                Tipo:
            </Form.Label>
            <Col sm={4}>
                <Form.Control
                    ref={register(typeValidationObj)}
                    as='select'
                    name='typeId'
                    defaultValue={holidayToEdit?.holidayType?.id || ''}
                >
                    <option value=''>Seleccione...</option>
                    {holidayTypeList?.map(holidayType =>
                        <option key={holidayType?.id} value={holidayType?.id}>
                            {holidayType?.name}
                        </option>
                    )}
                </Form.Control>
                <FormFieldError errors={errors?.typeId} />
            </Col>
        </Form.Group>
    </>
};

export default HolidayForm;